import { useLocation } from 'react-router-dom';
import { withReturnTo } from '../useReturnTo';

// Link to Refine your palate that brings people back to the page they started on; null on Refine itself
export const useRefinePath = () => {
  const { pathname, search } = useLocation();
  if (pathname === '/refine') return null;

  return withReturnTo('/refine', `${pathname}${search}`);
};
